'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactLazyLoad = require('react-lazy-load');

var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Report = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Report, _Component);

  function Report() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Report);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Report.__proto__ || (0, _getPrototypeOf2.default)(Report)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      requestSent: false,
      messages: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Report, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Report.scss');
      var hash = this.props.params.hash;

      if (['da4934', '51a59a', '921b04', '0f0027', 'b04921', '0270f0'].indexOf(hash) === -1) {
        return _react2.default.createElement(
          'h1',
          null,
          'Str\xE1nka neexistuje'
        );
      }

      if (typeof window !== 'undefined' && !this.state.requestSent) {
        this.setState({
          requestSent: true
        });

        var url = 'https://www.nenudimse.cz/mobile-api/' + hash;

        var request = _superagent2.default.get(url);

        request.end(function (err) {
          var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              body = _ref2.body;

          if (err) {
            console.log(err);
          } else {
            var messages = {};

            body.forEach(function (msg) {
              if (typeof messages[msg.message_hash] === 'undefined') {
                messages[msg.message_hash] = [];
              }

              messages[msg.message_hash].push(msg);
            });

            _this2.setState({
              messages: messages
            });
          }
        });
      }

      var lazyLoadOffset = 2000;
      var title = 'Dětský tábor ' + this.props.params.date;
      _moment2.default.locale('cs');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: title,
          meta: [{
            name: 'robots',
            content: 'noindex'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/detske-tabory/' + this.props.params.date + '/' + hash }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            (0, _keys2.default)(this.state.messages).map(function (key) {
              var msgs = _this2.state.messages[key];

              return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(['col-lg-8', 'col-lg-offset-2', 'col-md-12', styles.card]) },
                msgs.map(function (msg, ii) {
                  return _react2.default.createElement(
                    'div',
                    { key: msg.id },
                    ii === 0 && _react2.default.createElement(
                      'p',
                      { className: styles.date },
                      (0, _moment2.default)(msg.created).fromNow()
                    ),
                    msg.image_src && _react2.default.createElement(
                      _reactLazyLoad2.default,
                      { offsetBottom: lazyLoadOffset, offsetTop: lazyLoadOffset },
                      _react2.default.createElement('img', { src: 'https://www.nenudimse.cz/uploads/' + msg.image_src, className: 'img-responsive', alt: 'D\u011Btsk\xFD t\xE1bor Nenud\xEDm se' })
                    ),
                    msg.text && _react2.default.createElement(
                      'p',
                      { className: styles.text },
                      msg.text
                    )
                  );
                })
              );
            })
          )
        )
      );
    }
  }]);
  return Report;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = Report;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Report/Report.js
// module id = 1112
// module chunks = 0